import { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'

import senceCurrentSession from 'api/integrations/sence/currentSession'
import getConfig from 'api/integrations/sence/getConfig'
import { IntegrationConfigSence, ISenceIntegration } from 'models/integrations'

export type SenceIntegration = {
  authenticated: boolean
  loading: boolean
  isSence: boolean
  params: IntegrationConfigSence
  data?: ISenceIntegration
}

export const useSence = (): SenceIntegration => {
  const { course, loading } = useSelector((state: IMainState) => state.courses)

  const senceIntegration = course?.senceIntegration
  const isSence = !loading && !!senceIntegration?.state

  const [authenticated, setAuthenticated] = useState<boolean>(!isSence)
  const [loadingSence, setLoadingSence] = useState<boolean>(false)
  const [params, setParams] = useState<IntegrationConfigSence>({
    token: '',
    runOtec: '',
  })

  const getSence = useCallback(async () => {
    if (!isSence || !senceIntegration?.code) return
    setLoadingSence(true)
    const { valid, session } = await senceCurrentSession(senceIntegration.code)
    const { runOtec, token } = await getConfig()
    setParams({ runOtec, token, session })
    setAuthenticated(valid)
  }, [isSence, senceIntegration])

  useEffect(() => {
    getSence().finally(() => {
      setLoadingSence(false)
    })
  }, [getSence])

  return {
    isSence,
    authenticated: isSence ? authenticated : true,
    loading: loadingSence,
    params,
    data: senceIntegration,
  }
}

export default useSence
